"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockLinesToInkFile = exports.linesToTextFile = exports.compileInk = exports.parseCompileMessage = void 0;
const COMPILE_MESSAGE_REGEX = /^(?<level>.*):((\s')(?<file>.*)('))?\sline\s(?<lineNumber>\d+):\s(?<message>(\n|.)*)$/;
const MESSAGE_LEVEL_MAP = {
    ERROR: 'error',
    WARNING: 'warning',
    TODO: 'todo',
};
const parseCompileMessage = (rawMessage) => {
    try {
        const matchResult = COMPILE_MESSAGE_REGEX.exec(rawMessage);
        if (matchResult === null || matchResult === void 0 ? void 0 : matchResult.groups) {
            const { file, lineNumber, message } = matchResult.groups;
            const type = MESSAGE_LEVEL_MAP[matchResult.groups.level];
            if (type) {
                return {
                    type,
                    file,
                    lineNumber: parseInt(lineNumber),
                    message,
                };
            }
        }
    }
    catch (e) {
        const message = e instanceof Error ? e.message : 'Unknown error';
        return { message };
    }
    return { message: rawMessage };
};
exports.parseCompileMessage = parseCompileMessage;
const compileInk = ({ main, includes, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { JsonFileHandler, Compiler: InkCompiler, CompilerOptions, } = yield Promise.resolve().then(() => __importStar(require('inkjs')));
    const fileHandler = new JsonFileHandler(includes);
    const compiler = new InkCompiler(main, new CompilerOptions(null, [], true, null, fileHandler));
    let inkJson = null;
    try {
        const story = compiler.Compile();
        inkJson = (_a = story.ToJson()) !== null && _a !== void 0 ? _a : null;
    }
    catch (e) {
        // noop
    }
    return {
        inkJson,
        compilerMessages: [
            ...compiler.errors,
            ...compiler.warnings,
            ...compiler.authorMessages,
        ],
    };
});
exports.compileInk = compileInk;
const linesToTextFile = (lines) => {
    const linesToJoin = [...lines, ''];
    return linesToJoin.join('\n');
};
exports.linesToTextFile = linesToTextFile;
const blockLinesToInkFile = (blockLines) => {
    return (0, exports.linesToTextFile)(blockLines.map((bl) => bl.text));
};
exports.blockLinesToInkFile = blockLinesToInkFile;
